function fn_comp_cards() {
    var selector = $(".comp_cards");

    if(selector.length) {
        selector.on("click mouseenter",".elm_comp_item",function (e) {
            e.preventDefault();
            var item = $(this);

            selector.find(".elm_comp_item").each(function () {
                $(this).removeClass("active");
            });

            item.addClass("active");
        });

        selector.on("mouseleave",".elm_comp_item",function (e) {
            var item = $(this);

            item.removeClass("active");
        });
    }
}
